import { render, staticRenderFns } from "./GameComponent.vue?vue&type=template&id=4ec8d33e&scoped=true&"
import script from "./GameComponent.vue?vue&type=script&lang=js&"
export * from "./GameComponent.vue?vue&type=script&lang=js&"
import style0 from "./GameComponent.vue?vue&type=style&index=0&id=4ec8d33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8d33e",
  null
  
)

export default component.exports